<ng-container [formGroup]="model">
    @switch (field.input.type) {
        @case (inputType.CALENDAR) {
            <p-datePicker
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [firstDayOfWeek]="1"
                [dateFormat]="field.input.calendarConfiguration?.calendarDateFormat || 'dd/mm/yy'"
                [disabledDates]="field.input.calendarConfiguration?.disabledDates || []"
                [minDate]="field.input.calendarConfiguration?.minDate"
                [maxDate]="field.input.calendarConfiguration?.maxDate"
                (onSelect)="field.input.calendarConfiguration?.onSelect?.($event)"
                dataType="string"
                placeholder="..."
                appendTo="body"
                [view]="field.input.calendarConfiguration?.calendarView || 'date'"
                [attr.aria-invalid]="isInvalid">
            </p-datePicker>
        }

        @case (inputType.TIME) {
            <p-datePicker
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [timeOnly]="true"
                hourFormat="24"
                placeholder="..."
                dateFormat="hh:mm"
                dataType="string"
                [attr.aria-invalid]="isInvalid">
            </p-datePicker>
        }
    }
</ng-container>

<ng-template #readOnly>
    <app-reactive-read-only-field [field]="field" [model]="model"></app-reactive-read-only-field>
</ng-template>
